// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import clockFastForwardIcon from "@/assets/icons/clock-fast-forward.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ClockFastForwardIconProps = Omit<IconProps, "name">;

export function ClockFastForwardIcon(props: ClockFastForwardIconProps): React.ReactNode {
  return <Icon name={clockFastForwardIcon} {...props} />;
}
